import { render, staticRenderFns } from "./prestaConta.vue?vue&type=template&id=66706a81&"
import script from "./prestaConta.vue?vue&type=script&lang=js&"
export * from "./prestaConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports